<template>
    <div class="orderListSuccess">
        <div class="top">
            <div class="main">
                <div class="left">
                    <div class="img" v-if="product.selSpec && product.selSpec.specFile">
                        <img :src="imgBaseUrl + product.selSpec.specFile.key" alt="">
                    </div>
                    <div class="img" v-else>
                        <img v-if="product.coverFile" :src="imgBaseUrl + product.coverFile.key" alt="">
                    </div>
                    <div class="right">
                        <div class="title">
                            {{product.name}}
                        </div>
                        <div v-if="product.selSpec && product.selSpec.quotedPrice">
                            <div v-if="!config.isZhulogic || user.type === 2 || user.type === 3 || user.isVip === 1" class="price">¥{{product.selSpec.quotedPrice}}</div>
                            <div class="price" v-else><router-link :to="{name:'myAuthentication'}">成为认证设计师，查看价格 </router-link></div>
                        </div>
                        <div v-else>
                            <div class="price">暂无报价</div>
                        </div>

                        <div class="sku">
                            <span class="opricail">规格：</span>
                            <span class="detail">
                                {{product.selSpecInfo}}
                            </span>
                        </div>
                    </div>

                </div>
                <div class="right">
                    <div class="successed">
                        <img src="../../../images/sucessDialog.png" alt="">
                        已加入清单
                    </div>
                    <div class="num">
                        清单中已有{{listNum}}种商品
                    </div>
                    <div class="buttonSuccess">
                        <router-link :to="'/home/product/list/' + $route.query.orderId"><button class="back">返回产品详情页</button></router-link>
                        <router-link :to="'/my/detailedList/operate?id=' + $route.query.detailedListId"><button class="go">前往清单查看</button></router-link>
                    </div>
                </div>
            </div>
        </div>
        <!--相似的产品-->
        <div class="detail-similar list" v-if="similarities.length > 0">
            <div class="similar-title">
                <span>相似产品</span>
            </div>
            <MyWaterfall :list="similarities" type="product" @load="loadMore"></MyWaterfall>
        </div>
    </div>
</template>

<script>
    import api from '../../../api';
    import config from '../../../config/config';
    import store from '../../../store/index';
    import $store from 'vue-store';
    import MyWaterfall from '../../common/my-waterfall';
    export default {
        data() {
            return {
                imgBaseUrl: api.common.imgBaseUrl,
                config: config,
                num:this.$route.query.num,
                product: {
                    selSpecInfo: '',
                    selSpec: null,
                    selCustom: {},
                    selCustomInfo: '',
                    selCustomIds: [],
                    selCycle: {},
                    selNum: 1,
                    quotedPrice: 0,
                    name:''
                },
                filter: {
                    pageNum: 1,
                    productId: this.$route.query.orderId,
                    pageSize: 12
                },
                busy: false,
                listNum:0,
                similarities: [],
            }
        },
        computed: {
            user() {
                return this.$store.state.user.info;
            }
        },
        components:{ MyWaterfall},
        methods :{
            getDetailedListNum(){
                api.detailedLists.getDetailedList(this.$route.query.detailedListId, 2)
                    .then((res) => {
                       this.listNum =  res.products ? res.products.length : 0;
                    })
            },
            updateList() {
                this.busy = true;
                api.products.getSimilarities(this.filter)
                    .then(res => {
                        this.similarities = this.similarities.concat(res);
                        this.total = res.total;
                        this.busy = false;
                    }, () => {
                        this.busy = false;
                    });
            },
            loadMore() {
                if (this.filter.pageNum * this.filter.pageSize < this.total) {
                    this.filter.pageNum++;
                    this.updateList();
                }
            },
        },
        created(){
            api.products.getProduct(this.$route.query.orderId)
                .then((res) => {
                    Object.assign(this.product, res);
                    let selSpecs = this.product.specs.filter((item) => item.id === parseInt(this.$route.query.specId))[0];
                    this.product.selSpec = selSpecs;
                    this.product.selSpecInfo = [selSpecs.color,selSpecs.size, selSpecs.material].join(',');
                });
            this.getDetailedListNum();
            this.updateList();
        }
    }
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
    .orderListSuccess{
        width: 100%;
        .top{
            background: #fff;
            .main{
                width: 1220px;
                margin:0 auto;
                padding: 60px 0;
                .left{
                    display: inline-block;
                    width: 55%;
                    .img{
                        background: #EBEFF0;
                        display: inline-block;
                        width: 160px;
                        height: 160px;
                        text-align: center;
                        line-height: 160px;
                        margin-right: 20px;
                        img{
                            vertical-align: middle;
                        }
                    }
                    .right{
                        display: inline-block;
                        vertical-align: middle;
                        .title{
                            font-size: 20px;
                            color: #555555;
                            margin-bottom: 20px;
                        }
                        .price{
                            font-size: 20px;
                            color: #E14B5D;
                            margin-bottom: 30px;
                        }
                        .sku{
                            .opricail{
                                font-size: 14px;
                                color: #555555;
                                margin-right: 5px;
                                display: inline-block;
                                vertical-align: top;
                            }
                            .detail{
                                font-size: 14px;
                                color: #555555;
                                display: inline-block;
                                width: 392px;
                                height: auto;
                            }
                        }
                    }

                }
                .right{
                    float: right;
                    display: inline-block;
                    .successed{
                        font-size: 20px;
                        color: #353838;
                        margin-bottom: 60px;
                        img{
                            width: 30px;
                            height: 30px;
                            margin-right: 12px;
                            vertical-align: top;
                        }
                    }
                    .num{
                        font-size: 14px;
                        color: #E14B5D;
                        margin-bottom: 10px;
                    }
                    .buttonSuccess{
                        button.back{
                            border: 2px solid #308697;
                            border-radius: 4px;
                            height: 40px;
                            width: 120px;
                            text-align: center;
                            font-size: 14px;
                            color: #308697;
                            margin-right: 10px;
                            background: #FFFFFF;
                            &:hover{
                                opacity: 0.8;
                            }
                        }
                        button.go{
                            background: #308697;
                            border-radius: 4px;
                            font-size: 14px;
                            color: #FFFFFF;
                            height: 40px;
                            width: 120px;
                            text-align: center;
                            line-height: 40px;
                            &:hover{
                                opacity: 0.8;
                            }
                        }
                    }
                }
            }
        }
        /*相似*/
        .detail-similar.list {
            clear: both;
        }

        .detail-similar.list .white-btn {
            margin: 30px auto;
            border: 2px solid #DCE0E0;
            width: 228px;
            height: 40px;
            line-height: 36px;
            color: #6C6F70;
            display: block;
        }

        .detail-similar.list .similar-title {
            text-align: left;
            font-size: 16px;
            margin-left: 10px;
            margin-top: 68px;
        }

        .detail-similar.list .similar-content .content-img {
            width: 15%;
            height: auto;
            margin-top: 10px;
            float: left;
            margin-right: 15px;
        }

        .detail-similar.list .similar-content .content-img img {
            width: 100%;
            height: 100%;
        }
    }
</style>